export var HolidayMutationTypes;
(function (HolidayMutationTypes) {
    HolidayMutationTypes["FETCH_HOLIDAY"] = "FETCH_HOLIDAY";
})(HolidayMutationTypes || (HolidayMutationTypes = {}));
